angular.module('rightPaneModule')
  .controller('ClassroomActivityController', [
      '$scope',
      '$state',
      'activityApi',
      'compareDay',
      'infiniteScroll',
      'authentication',
      'reportErrors',
      'edxDateTimeService',
      'translateFilter',
    function(
        $scope,
        $state,
        $activityApi,
        $compareDay,
        $infiniteScroll,
        dblAuthentication,
        $reportErrors,
        dateTimeService,
        translateFilter)
    {
    var computedFromDate = new Date();
    var computedToDate = new Date().setDate(computedFromDate.getDate() - 29);

    $scope.activityFeedFrom = computedFromDate;
    $scope.activityFeedTo = computedToDate;

    $scope.fromDateDay = dateTimeService.dayOfWeekOrToday(computedFromDate);
    $scope.toDateDay = dateTimeService.dayOfWeekOrToday(computedToDate);

    var NO_EVENTS_MESSAGE = translateFilter('errors.noEventsClassroom');
    var NO_MORE_EVENTS_MESSAGE = translateFilter('errors.noMoreEventsClassroom');

    $scope.showStudentNames = true; // At the classroom level need to display names on the card.

    var updateClassroomActivities = function() {
        $activityApi.getClassroomActivities().then(function(data) {
            // initialize the next page data
            $infiniteScroll.handlePageResponse($scope, data);
            $scope.events = ($scope.events || []).concat(data.activities);
            updateNoDataMessage();
        }, function(error) {
            $scope.activityError = $reportErrors.getErrorMessage(error);
        });
    };

    var updateNoDataMessage = function () {
        if (!$scope.events.length) {
            $scope.noDataMessage = NO_EVENTS_MESSAGE;
        } else if ($scope.endOfPage) {
            $scope.noDataMessage = NO_MORE_EVENTS_MESSAGE;
        } else {
            $scope.noDataMessage = undefined;
        }
    };

    var initializeData = function(e, item) {
        // IN-618 include today
        $compareDay.resetGroupedByDate(true);
        $scope.item = item;

        // TODO: not generally sure when it's safe to call getCustomer. Putting after the item loads
        // seems safe enough. Consider promise or observable for this sort of thing.
        var customer = dblAuthentication.getCustomer();

        $scope.classroomActivitiesExportUrl = $activityApi.getClassroomActivitiesExportUrl();
        updateClassroomActivities();
    };

    $scope.$on('itemReady', initializeData);
    $infiniteScroll.init($scope, updateClassroomActivities);
  }]);
